import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '@app/currency';
import { Events, useGATrackEvent } from '@app/analytics';
import { EVENTS, trackEvent } from '@app/segment';
import { useLinkState, useSubNav } from './hooks';
import {
  DropdownContainer,
  DropdownLink,
  DropdownMenu,
  DropdownMenuItem,
} from '../../DropdownNav';

const Sell = () => {
  const linkState = useLinkState();
  const { t } = useTranslation();
  const { currency } = useCurrency();
  const trackGA = useGATrackEvent();
  const subNavItems = useSubNav();

  const handleNavClick = () => {
    trackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
      label: 'Sell',
    });
    trackGA(
      Events.NavSellClick,
      null,
      null,
      null,
      {},
      {
        currency,
      },
    );
  };

  const handleMenuItemClick = (label, onClose) => {
    trackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
      label,
    });
    trackGA(
      Events.NavSellClick,
      null,
      label,
      null,
      {},
      {
        currency,
      },
    );
    onClose();
  };

  return (
    <DropdownContainer key="sell" data-testid="navbar-menu-sell">
      {({ onClose }) => (
        <>
          <DropdownLink
            to={{ pathname: '/sell', state: linkState }}
            onClick={handleNavClick}
          >
            {t('Sell')}
          </DropdownLink>
          <DropdownMenu>
            {subNavItems.map(({ Icon, label, to, isExternal }) => (
              <DropdownMenuItem
                key={label}
                Icon={Icon}
                label={label}
                to={to}
                onClick={() => handleMenuItemClick(label, onClose)}
                isExternal={isExternal}
              />
            ))}
          </DropdownMenu>
        </>
      )}
    </DropdownContainer>
  );
};

export default Sell;
